import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild, model, output, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ICurrentUser } from '../../models';
import { UserService } from '../../services';
import { AdminCardComponent } from '../admin-card/admin-card.component';
import { AppsCardComponent } from '../apps-card/apps-card.component';
import { HelpCardComponent } from '../help-card/help-card.component';
import { UserCardComponent } from '../user-card/user-card.component';
import { ImpersonationCurrentComponent } from '../../../../features/admin/components';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ShortcutsCardComponent } from '../../../../features/workbench/components/shortcuts-card/shortcuts-card.component';
import { QuicklinksComponent } from '../../../../features/quicklinks/quicklinks.component';
import { FeatureAccessService } from '../../../../../services/framework/featureaccess.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass
    , AppsCardComponent
    , AdminCardComponent
    , UserCardComponent
    , HelpCardComponent
    , ImpersonationCurrentComponent
    , ShortcutsCardComponent
    , QuicklinksComponent
  ]
})
export class TopbarComponent implements OnInit, OnDestroy {
  @Output() toggleMenu: EventEmitter<any> = new EventEmitter();
  currentUser: ICurrentUser;
  attemptCount: number = 0;
  maxAttempts: number = 10;
  enableAdminicon: boolean = false;
  protected impersonationEmail = model('');
  public impersonateChanged = output<string>();

  // New version of viewChild problematic - with undefined, so reverted to old style
  @ViewChild(AdminCardComponent, { static: false })
  protected compMenuAdmin!: AdminCardComponent;

  @ViewChild(UserCardComponent, { static: false })
  protected compMenuUser!: UserCardComponent;

  protected destroy$ = new Subject();

  constructor(private router: Router
    , private userService: UserService, private featureaccess: FeatureAccessService) {
    this.currentUser = userService.emptyUser;
  }

  async ngOnInit() {
    await this.userService.getCurrentRoles(true);

    this.checkLocalStorage("currentFeatures");
    this.refreshUser();
  }
  checkLocalStorage(key: string) {
    const datafeature = localStorage.getItem(key);
    if (datafeature) {
      var isShowRoles = this.featureaccess.getAccessPermission('/admin/roles')
        || this.featureaccess.getAccessPermission('/admin/users')
        || this.featureaccess.getAccessPermission('/admin/features')
        || this.featureaccess.getAccessPermission('/Admin/AIHub')
        || this.featureaccess.getAccessPermission('/salesanddeliveryhub/Taxonomy')
        || this.featureaccess.getAccessPermission('/salesanddeliveryhub/UploadFiles')
        || this.featureaccess.getAccessPermission('/ideaverse/list')
        || this.featureaccess.getAccessPermission('/createwordoftheweek/curation')
        || this.featureaccess.getAccessPermission('/smartbank/curation');

      if (isShowRoles) {
        this.enableAdminicon = true;
      }

      //var isShowUsers = this.featureaccess.getAccessPermission('/admin/users');
      //if (isShowUsers) {
      //  this.enableAdminicon = true;
      //}
      //var isShowFeatures = this.featureaccess.getAccessPermission('/admin/features');
      //if (isShowFeatures) {
      //  this.enableAdminicon = true;
      //}


    } else {
      this.attemptCount++;
      if (this.attemptCount < this.maxAttempts) {
        setTimeout(() => {
          this.checkLocalStorage(key);
        }, 1000);
      } else {
      }
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  navHome() {
    this.router.navigate(['home']);
  }

  public refreshUser() {

    this.userService.getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: ICurrentUser) => {
        this.currentUser = user;
      });
  }

  public menuClick() {
    this.toggleMenu.emit(null);
  }

  protected onImpersonateChanged(email: string) {
    this.impersonationEmail.set(email);
    this.impersonateChanged.emit(email);

    this.compMenuAdmin.refreshMenu();
    this.compMenuUser.refreshUser();
  }

}
